document.addEventListener("DOMContentLoaded", () => {
    const trigger = document.querySelector("[data-open-size-table]");
    const table = document.querySelector("[data-size-chart]");

    if (!trigger || !table) return;

    const toggleTable = () => {
        const willOpen = table.hidden;

        table.hidden = !table.hidden;
        trigger.classList.toggle("is-open", willOpen);

        // if (willOpen) {
        //     table.scrollIntoView({
        //         behavior: "smooth",
        //         block: "start",
        //         inline: "nearest",
        //     });
        // }
    };

    trigger.addEventListener("click", toggleTable);

    trigger.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            toggleTable();
        }
    });
});
